const data = [
  {
    title: 'Agile Schedule',
    body:
      'The speed of a delivery matters a lot. Be sure, that whatever the location and package, we’ll always be in time!',
  },
  {
    title: 'Experienced Staff',
    body:
      'When hiring us, a crew of experienced drivers, loaders, and delivery couriers is at your command!',
  },
  {
    title: 'Safety-Oriented',
    body:
      'We’re used to transporting both oversized packages and items, just as well as fragile and electronics!',
  },
];

export default data;
